function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ButtonUploadExcel from '@/components/ButtonUploadExcel';
import { excelTemplateApi } from '@/api/componentsApi';
import * as pintuanApi from '@/api/pintuanApi';
import SelectPintuan from './selectPintuan.vue';
import throttle from '@/utils/throttle';
import * as dangaoActApi from '@/api/dangaoActApi';
export default {
  components: {
    ButtonUploadExcel: ButtonUploadExcel,
    SelectPintuan: SelectPintuan
  },
  data: function data() {
    return {
      FROM_TYPE_OPTIONS: [{
        value: 1,
        label: '自营'
      }, {
        value: 2,
        label: '福司令'
      }],
      title: '',
      tableData: {
        list: [],
        total: 0
      },
      pageFrom: {
        page: 1,
        limit: 15
      },
      loading: false,
      // 表格loading
      customerId: null,
      ids: [],
      brandOption: [],
      ljcType: null
    };
  },
  created: function created() {
    if (this.$getHomeType()) {
      this.ljcType = this.$getHomeType().ljcType;
    }
    var _ref = this.$route.query || {},
      name = _ref.name,
      id = _ref.id;
    this.title = name;
    this.customerId = id;
    this.getList();
    this.searchBrand('');
  },
  mounted: function mounted() {
    this.DeleteCouponVueRef = this.$refs.DeleteCouponVueRef;
  },
  methods: {
    throttle: throttle,
    searchBrand: function searchBrand() {
      var _this = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      dangaoActApi.getAllDangaoBrand(keyword).then(function (res) {
        _this.brandOption = res && res.length && res.map(function (item) {
          var _ref2 = item || {},
            brandId = _ref2.brandId,
            brandName = _ref2.brandName,
            source = _ref2.source;
          return {
            id: brandId,
            brandName: brandName,
            brandStr: "".concat(brandName, "--ID").concat(brandId, "\u3010").concat(source, "\u3011")
          };
        }) || [];
      });
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this2 = this;
      this.throttle(function () {
        _this2.searchBrand(data);
      }, 300)();
    },
    search: function search() {
      this.pageFrom.page = 1;
      if (!this.pageFrom.brandId) {
        this.searchBrand('');
      }
      ;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageFrom.limit = size;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.pageFrom.page = page;
      this.getList();
    },
    addPintuanGoods: function addPintuanGoods() {
      var _this$$refs$SelectPin;
      (_this$$refs$SelectPin = this.$refs['SelectPintuanRef']) === null || _this$$refs$SelectPin === void 0 ? void 0 : _this$$refs$SelectPin.openInit(this.customerId);
    },
    //导出
    exportCustomerSku: function exportCustomerSku() {
      var params = _objectSpread(_objectSpread(_objectSpread({}, this.pageFrom), this.searchForm), {}, {
        customerId: this.customerId
      });
      dangaoActApi.exportBindCake(params).then(function (res) {
        window.open(res.fileName);
      });
    },
    //导出模板
    exportTemp: function () {
      var _exportTemp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return excelTemplateApi('customerSku.xlsx');
            case 1:
              _res = _context.v;
              window.open(_res.fileName);
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error(_t.message);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function exportTemp() {
        return _exportTemp.apply(this, arguments);
      }
      return exportTemp;
    }(),
    //列表选择
    handleSelectionChange: function handleSelectionChange(val) {
      this.ids = val.map(function (item) {
        return item.id;
      });
    },
    //批量移除
    deleteBatch: function deleteBatch(deletId) {
      var _this3 = this;
      var idList = deletId ? [deletId] : this.ids;
      if ((idList === null || idList === void 0 ? void 0 : idList.length) == 0) {
        this.$message.error('请选择要删除的数据！');
        return;
      }
      ;
      this.$confirm('删除后不能恢复，是否确认删除？', '提示', {
        type: 'warning'
      }).then(function (result) {
        dangaoActApi.deleteBindCake(idList).then(function (res) {
          _this3.$message.success('操作成功');
          _this3.search();
        });
      });
    },
    // 列表
    getList: function getList() {
      var _this4 = this;
      this.loading = true;
      dangaoActApi.getDangaoBusinesss(_objectSpread(_objectSpread({}, this.pageFrom), {}, {
        customerId: this.customerId
      })).then(function (res) {
        _this4.tableData = res;
        _this4.tableData.list = res.list;
        _this4.loading = false;
      }).catch(function (err) {
        _this4.loading = false;
      });
    },
    changePrice: function changePrice(row) {
      var _this5 = this;
      var _ref3 = row || {},
        id = _ref3.id,
        sellPrice = _ref3.sellPrice,
        supplyPrice = _ref3.supplyPrice,
        status = _ref3.status;
      dangaoActApi.changeBindCakePrice({
        id: id,
        sellPrice: sellPrice,
        supplyPrice: supplyPrice,
        status: status
      }).then(function (res) {
        _this5.$message.success('操作成功');
        _this5.getList();
      }).catch(function (err) {
        _this5.getList();
        _this5.$message.error(res.message);
      });
    },
    // 导入
    beforeUpload: function beforeUpload(file, type) {
      var _this6 = this;
      var formData = new FormData();
      formData.append('file', file);
      dangaoActApi.importProductCakeBind(formData, Number(this.customerId)).then(function (res) {
        _this6.$message.success('导入成功！');
        _this6.search();
      });
    },
    // 修改状态
    onchangeIsShow: function onchangeIsShow(row) {
      var _this7 = this;
      var _ref4 = row || {},
        id = _ref4.id,
        status = _ref4.status;
      dangaoActApi.changeBindCakePrice({
        id: id,
        status: status
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this7.$message.success('修改成功');
              _this7.handlerGetListData();
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))).catch(function () {
        _this7.handlerGetListData();
      });
    }
  }
};